import PointApi from '@apis/point/PointApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetPointCardsParams, GetPointHistoryParams } from '@models/point';

const pointQueries = createQueryKeys('point', {
    cardList: (params: GetPointCardsParams) => ({
        queryKey: [params],
        queryFn: () => PointApi.getCards(params),
    }),
    history: (param: GetPointHistoryParams) => ({
        queryKey: [param],
        queryFn: () => PointApi.getPointHistory(param),
    }),
});

export default pointQueries;
